import { Skeleton } from 'antd';
import React from 'react';

const CardSkeleton = ({ count = 3 }) => {
    return (
        <div className="space-y-4">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="bg-white border border-[#d4d9e3] rounded-xl p-4">
                    <div className="flex items-start gap-3">
                        <div className="flex-1 space-y-3">
                            <div className="flex justify-between items-start">
                                <div className="flex-1">
                                    <Skeleton.Input active size="small" style={{ width: '60%' }} />
                                </div>
                                <Skeleton.Button active size="small" shape="round" style={{ width: '80px' }} />
                            </div>
                            <div className="space-y-2">
                                <div className="flex justify-between">
                                    <Skeleton.Input active size="small" style={{ width: '30%' }} />
                                    <Skeleton.Input active size="small" style={{ width: '40%' }} />
                                </div>
                                <div className="flex justify-between">
                                    <Skeleton.Input active size="small" style={{ width: '30%' }} />
                                    <Skeleton.Input active size="small" style={{ width: '50%' }} />
                                </div>
                                <div className="flex justify-between">
                                    <Skeleton.Input active size="small" style={{ width: '30%' }} />
                                    <Skeleton.Input active size="small" style={{ width: '45%' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CardSkeleton;
